import { normalizeStructureKey } from './systemStructure.utils';

const getDeviceTypeLookupKey = (systemType, deviceType) =>
  `${normalizeStructureKey(systemType)}::${normalizeStructureKey(deviceType)}`;

export const getSystemMeta = (structure, systemType) =>
  structure?.systemTypesByName?.get(normalizeStructureKey(systemType));

export const getDeviceTypeMeta = (structure, systemType, deviceType) =>
  structure?.deviceTypesByKey?.get(getDeviceTypeLookupKey(systemType, deviceType));

export const getDeviceTypesForSystem = (structure, systemType) =>
  getSystemMeta(structure, systemType)?.device_types || [];

export const getLegacyDeviceTypeMap = (structure) =>
  (structure?.systemTypes || []).reduce((map, systemType) => {
    map[systemType.name] = (systemType.device_types || []).reduce((deviceTypeMap, deviceType) => {
      deviceTypeMap[deviceType.name] = deviceType.source || {};
      return deviceTypeMap;
    }, {});
    return map;
  }, {});
